import dayjs from 'dayjs';

import { MESSENGER } from 'constants/chats';
import { getFilteredPlatforms } from 'utils/platform';

import SelectBusinessAndPageModal from 'components/connectPlugin/components/SelectBusinessAndPageModal/SelectBusinessAndPageModal';
import SetupConnectionModal from 'components/Pixels/components/ConversationalCommerce/components/SetupConnectionModal';
import { fmt } from 'components/IntlWrapper/IntlWrapper';
import { sendSegment } from 'utils/segment';

export const targetPlatform = (platform, businessInfo) =>
  getFilteredPlatforms(businessInfo).find(
    (platformItem) => platformItem.keyName === platform
  );

export const connectedPlugins = (businessInfo) =>
  getFilteredPlatforms(businessInfo).filter(
    (platform) =>
      businessInfo?.featuresConfigurations?.plugins?.omniMessaging?.[
        platform?.keyName
      ]?.gaveAccess
  );

export const handleConnectionPlugin = (
  platform,
  businessInfo,
  LoggedPlatform,
  handleLoginToMeta,
  currentPlatform,
  handleSyncProducts,
  handleDisconnection,
  setLoggedPlatform,
  openModal
) => {
  sendSegment('SLLR_CHAT_START_CONNECTION', {
    CHANNEL: platform?.keyName,
    EVENT_DATE: dayjs().format('YYYY-MM-DD'),
    BUSINESS_ID: businessInfo?._id
  });

  localStorage.setItem('currentPlugin', JSON.stringify(platform));
  if (LoggedPlatform === platform?.keyName && window.FB.getAccessToken()) {
    openModal(SelectBusinessAndPageModal, {
      handleLoginToMeta,
      platform,
      currentPlatform: currentPlatform(platform),
      cb: ({ metaBusinessId, pageId }) => {
        handleSyncProducts({
          metaBusinessId,
          pageId,
          platform: platform?.keyName
        });
      }
    });
  } else if (
    businessInfo?.featuresConfigurations?.plugins?.omniMessaging?.[
      platform.keyName
    ]?.gaveAccess
  ) {
    handleDisconnection(platform.keyName.toUpperCase());
  } else {
    openModal(SetupConnectionModal, {
      handleLoginToMeta,
      platform,
      currentPlatform: currentPlatform || currentPlatform(platform),
      setLoggedPlatform
    });
  }
};

export const platformLocalize = (platform) => {
  switch (platform?.toLowerCase()) {
    case MESSENGER:
      return fmt({ id: 'chats_plugins.install_plugins.facebook_messenger' });
    default:
      return fmt({ id: 'chats_plugins.install_plugins.instagram_messenger' });
  }
};

export const checkIsSafari = () => {
  const userAgent = navigator.userAgent;
  const isSafari =
    /safari/i.test(userAgent) && !/chrome|crios|fxios|edg/i.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  return { isSafari, isIOS };
};
